import React from 'react';
import ReactDOM from 'react-dom';
import MyRouter from 'Router/Router.js';
import * as serviceWorker from './serviceWorker';
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'datatables/media/css/jquery.dataTables.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import './index.scss';
import $ from "jquery"

window.$ = $
window.jQuery = window.$

ReactDOM.render(<MyRouter />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
